/**
 * JSON за вграждане в <script type="application/ld+json">.
 *
 * Голият JSON.stringify НЕ е безопасен в HTML: низ с `</script>` затваря тага и
 * останалото става жив HTML. В JSON-LD-то влизат текстове от клиенти (ревюта, име
 * на автора) и от адреса (breadcrumb) — до 22.10.2026 това беше съхранен XSS.
 * Escape-ът е препоръчаният от Next.js (`<` → <); JSON-ът остава еквивалентен.
 */
export function serializeJsonLd(value) {
  return JSON.stringify(value)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}
